module.exports = __webpack_public_path__ + "static/antes de usar cup-c5b5b651ea1a6427558e4beaf033f27d.webp";